import {User} from "oidc-client-ts";

function getUser() {
  const oidcStorage = localStorage.getItem(`oidc.user:https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_ZAn0QVMcW:uncfkh6mf62lqi1kjfh6l1749`)
  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage);
}

async function getToken() {
  const user = getUser();
  return user?.id_token;
}

async function getAccessToken() {
  const user = getUser();
  const token = user?.access_token;
}

function isAdmin() {
  const user = getUser();
  const { 'cognito:groups': groups } = user.profile;
  return Array.isArray(groups) && groups.includes("Admins");
}

function getUserId() {
  const user = getUser();
  return user?.profile.sub
}

function getAccountHolderId() {
  const user = getUser();
  if (user) {
    const {'custom:accountHolderIds': accountHolderIds} = user?.profile;
    if (!accountHolderIds & isAdmin()) {
      return "admin";
    }
    return accountHolderIds?.split(',')[0];
  }
  return null;
}

function getUserName() {
  const user = getUser();
  return user?.profile.name
}


export { getToken, isAdmin, getUserId, getUserName, getAccessToken, getAccountHolderId };